module Meevo.Components.Controls.SmartMover {
    export class ResourcesCollection extends SmartMoverApiCollection<Model.Resource> implements IApiCollection<Model.Resource> {

        get url() {
            return 'Resource';
        }

        constructor(connectedModel: ModelValueType[], items: Model.Resource[] = [], options: ICollectionOptions<Model.Resource> = {}) {
            super(connectedModel, items, options);
        }
    }

}